<template>
  <div class="chat-container">
    <!-- 欢迎屏幕 -->
    <div v-if="showWelcome" class="welcome-screen">
      <h2>欢迎参加面试</h2>
      <p>请确保您的设备已连接麦克风并打开。</p>
      <p>您总共需要回答三个问题。</p>
      <p>题目会语音播报给您。</p>
      <p>当语音结束请开始作答。</p>
      <p>每道问题你有10秒钟的时间作答。</p>
      <p>祝好运！</p>
      <p>点击下方按钮开始面试</p>
      <el-button type="primary" @click="startInterview">开始面试</el-button>
    </div>
    <!-- 对话历史区域 -->
    <div v-else-if="showRes">
      <InterviewRecord :view="resView" :view_item="resItem" />
    </div>
    <div v-else class="chat-history">
      <el-scrollbar >
        <div class="interview-round" v-show="currentRound >= 1">
          <h3>第一轮问答</h3> 
          <div
          style="display: none;">{{ messages.item1_txt }}</div>
          <audio
          style="display: none;"  :src="'/'+messages.item1_src" controls  autoplay class="question-audio"  @ended="autoStartRecording"></audio>
          <div v-if=" isPlaying==1" class="audio-playing-indicator">
            <span class="dot"></span>
            <span class="dot"></span>
            <span class="dot"></span>
          </div>
          <div class="voice-input-container" v-if="!wav1 && currentRound === 1">
            <el-button
            style="display: none;"
              type="primary"
              circle
              class="voice-button"
              v-if="micPermissionGranted"
              @mousedown=" startRecording"
              @mouseup=" stopRecording"
              @mouseleave=" stopRecording"
              @touchstart.prevent=" startRecording"
              @touchend.prevent=" stopRecording"
              @touchcancel.prevent=" stopRecording"
            >
              <el-icon>
                <component :is="recording ? Microphone : MicrophoneOutlined" />
              </el-icon>
            </el-button>
            <div
            style="display: none;" class="voice-hint">{{ !micPermissionGranted ? '请允许麦克风权限' : (recording ? '松开发送' : '按住说话') }}</div>
            <div v-if="recording" class="recording-time">{{ recordingTime }}</div>
          </div>
          <div v-else-if="wav1" class="recorded-answer">
            <p>已完成回答</p>
            <audio
            style="display: none;"  v-if="wav1Preview" :src="wav1Preview" controls class="answer-audio"></audio>
            <el-button type="primary" @click="nextRound" v-if="currentRound === 1">下一题</el-button>
          </div>
        </div>

        <div class="interview-round" v-show="currentRound >= 2">
          <h3>第二轮问答</h3> 
          <div
          style="display: none;">{{ messages.item2_txt }}</div>
          <audio style="display: none;" id="q2" :src="'/'+messages.item2_src" controls  playsinline class="question-audio" @ended="autoStartRecording"></audio>
          <div v-if="isPlaying==2" class="audio-playing-indicator">
            <span class="dot"></span>
            <span class="dot"></span>
            <span class="dot"></span>
          </div>
          <div class="voice-input-container" v-if="!wav2 && currentRound === 2">
            <el-button
            style="display: none;"
              type="primary"
              circle
              class="voice-button"
              @mousedown="startRecording"
              @mouseup="stopRecording"
              @mouseleave="stopRecording"
              @touchstart.prevent="startRecording"
              @touchend.prevent="stopRecording"
              @touchcancel.prevent="stopRecording"
            >
              <el-icon>
                <component :is="recording ? Microphone : MicrophoneOutlined" />
              </el-icon>
            </el-button>
            <div
            style="display: none;" class="voice-hint">{{ recording ? '松开发送' : '按住说话' }}</div>
            <div v-if="recording" class="recording-time">{{ recordingTime }}</div>
          </div>
          <div v-else-if="wav2" class="recorded-answer">
            <p>已完成回答</p>
            <audio
            style="display: none;" v-if="wav2Preview" :src="wav2Preview" controls class="answer-audio"></audio>
            <el-button type="primary" @click="nextRound" v-if="currentRound === 2">下一题</el-button>
          </div>
        </div>

        <div class="interview-round" v-show="currentRound >= 3">
          <h3>第三轮问答</h3> 
          <div
          style="display: none;">{{ messages.item3_txt }}</div>
          <audio style="display: none;" id="q3"  :src="'/'+messages.item3_src" controls  class="question-audio"  @ended="autoStartRecording"></audio>
          <div v-if="isPlaying==3" class="audio-playing-indicator">
            <span class="dot"></span>
            <span class="dot"></span>
            <span class="dot"></span>
          </div>
          <div class="voice-input-container" v-if="!wav3 && currentRound === 3">
            <el-button
            style="display: none;"
              type="primary"
              circle
              class="voice-button"
              @mousedown="startRecording"
              @mouseup="stopRecording"
              @mouseleave="stopRecording"
              @touchstart.prevent="startRecording"
              @touchend.prevent="stopRecording"
              @touchcancel.prevent="stopRecording"
            >
              <el-icon>
                <component :is="recording ? Microphone : MicrophoneOutlined" />
              </el-icon>
            </el-button>
            <div
            style="display: none;" class="voice-hint">{{ recording ? '松开发送' : '按住说话' }}</div>
            <div v-if="recording" class="recording-time">{{ recordingTime }}</div>
          </div>
          <div v-else-if="wav3" class="recorded-answer">
            <p>已完成回答</p>
            <audio
            style="display: none;" v-if="wav3Preview" :src="wav3Preview" controls class="answer-audio"></audio>
            <div v-if="currentRound === 3">完成面试 请在此页面等待3-5分钟，面试结果马上呈现</div>
          </div>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue';
import { useRoute } from 'vue-router';
import { postData } from '@/api.js';
import { Microphone, MicrophoneOutlined } from '@element-plus/icons-vue';
import { ElMessage } from 'element-plus';
import InterviewRecord from '@/components/InterviewRecord.vue';

export default {
  name: 'View',
  components: {
    Microphone,
    MicrophoneOutlined,
    InterviewRecord
  },
  setup() {
    const messages = ref({});
    const recording = ref(false);
    const currentRound = ref(1);
    const route = useRoute();
    const recordingTime = ref('00:10');
    let timerInterval = null;
    const wav1 = ref(null);
    const wav2 = ref(null);
    const wav3 = ref(null);
    const wav1Preview = ref(null);
    const wav2Preview = ref(null);
    const wav3Preview = ref(null);
    const showRes=ref(false);
    const resView=ref(null);
    const resItem=ref(null);
    const micPermissionGranted = ref(false);
    const showWelcome = ref(true);
    const isPlaying = ref(1);

    // 开始面试
    const startInterview = async () => {
      try {
        await getPermission();
        if (micPermissionGranted.value) {
          showWelcome.value = false;
          await fetchInterviewData();
        }
      } catch (error) {
        console.error('开始面试失败:', error);
      }
    };

    // 获取面试数据
    const fetchInterviewData = async () => {
      try {
        const id = route.params.id;
        if (id) {
          const response = await postData(`view`,{id});
          if (response.data) {
            messages.value = response.data || {};
           
            
          }
        }
      } catch (error) {
        console.error('获取面试数据失败:', error);
      }
    };
    const getPermission = async () => {
      try {
        await navigator.mediaDevices.getUserMedia({ audio: true });
        micPermissionGranted.value = true;
        // alert(22);
        console.log('xxx',micPermissionGranted.value)
      } catch (error) {
        if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
          ElMessage.error('请允许访问麦克风权限');
        } else {
          ElMessage.error('无法访问麦克风，请检查设备连接');
        }
      }
    };
    onMounted(() => {
      // 初始化时不再自动请求权限和数据
    });
    let mediaRecorder = null;
    // let audioChunks = [];

    // 开始录音
    const startRecording = async () => {
      try {
        // 检查浏览器是否支持AudioContext
        if (!window.AudioContext && !window.webkitAudioContext) {
          ElMessage.error('您的浏览器不支持录音功能，请使用最新版本的浏览器');
          return;
        }

        // 请求音频权限
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: {
            echoCancellation: true,
            noiseSuppression: true,
            sampleRate: 44100
          }
        });

        // 创建音频上下文
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        const audioContext = new AudioContext();
        const mediaStreamSource = audioContext.createMediaStreamSource(stream);
        const recorder = audioContext.createScriptProcessor(4096, 1, 1);

        const audioChunks = [];
        recorder.onaudioprocess = (e) => {
          const audioData = e.inputBuffer.getChannelData(0);
          audioChunks.push(new Float32Array(audioData));
        };

        mediaStreamSource.connect(recorder);
        recorder.connect(audioContext.destination);

        recording.value = true;

        // 开始计时
        let startTime = Date.now();
        timerInterval = setInterval(() => {
          const elapsedTime = Date.now() - startTime;
          const remainingSeconds = Math.max(0, 10 - Math.floor(elapsedTime / 1000));
          recordingTime.value = `00:${remainingSeconds.toString().padStart(2, '0')}`;
          
          // 当倒计时结束时自动停止录音
          if (remainingSeconds === 0) {
            stopRecording();
          }
        }, 1000);

        // 保存录音相关对象以便停止时使用
        mediaRecorder = {
          stream,
          audioContext,
          recorder,
          mediaStreamSource,
          audioChunks
        };
      } catch (error) {
        console.error('录音失败:', error);
        if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
          ElMessage.error('请允许访问麦克风权限');
        } else {
          ElMessage.error('录音失败，请检查设备连接并重试');
        }
        throw error;
      }
    };

    // 停止录音
    const stopRecording = () => {
      if (recording.value && mediaRecorder) {
        recording.value = false;

        // 停止计时
        if (timerInterval) {
          clearInterval(timerInterval);
          recordingTime.value = '00:00';
        }

        // 断开音频连接
        mediaRecorder.mediaStreamSource.disconnect();
        mediaRecorder.recorder.disconnect();

        // 停止所有音轨        mediaRecorder.stream.getTracks().forEach(track => track.stop());

        // 将录音数据转换为WAV格式
        const audioData = mergeBuffers(mediaRecorder.audioChunks);
        const wavBlob = createWavBlob(audioData, mediaRecorder.audioContext.sampleRate);

        // 创建音频预览URL
        const audioUrl = URL.createObjectURL(wavBlob);

        // 转换为base64
        const reader = new FileReader();
        reader.readAsDataURL(wavBlob);
        reader.onloadend = () => {
          const base64data = reader.result;
          
          // 根据当前轮次保存录音数据
          switch (currentRound.value) {
            case 1:
              wav1.value = base64data;
              wav1Preview.value = audioUrl;
              nextRound();
              break;
            case 2:
              wav2.value = base64data;
              wav2Preview.value = audioUrl;
              nextRound();
              break;
            case 3:
              wav3.value = base64data;
              wav3Preview.value = audioUrl;
              finishInterview();
              break;
          }
        };

        // 清理录音相关对象
        mediaRecorder.audioContext.close();
        mediaRecorder = null;
      }
    };

    // 合并音频缓冲区
    const mergeBuffers = (buffers) => {
      const totalLength = buffers.reduce((acc, buf) => acc + buf.length, 0);
      const result = new Float32Array(totalLength);
      let offset = 0;
      buffers.forEach(buffer => {
        result.set(buffer, offset);
        offset += buffer.length;
      });
      return result;
    };

    // 创建WAV文件
    const createWavBlob = (audioData, sampleRate) => {
      const buffer = new ArrayBuffer(44 + audioData.length * 2);
      const view = new DataView(buffer);

      // WAV文件头
      writeString(view, 0, 'RIFF');
      view.setUint32(4, 36 + audioData.length * 2, true);
      writeString(view, 8, 'WAVE');
      writeString(view, 12, 'fmt ');
      view.setUint32(16, 16, true);
      view.setUint16(20, 1, true);
      view.setUint16(22, 1, true);
      view.setUint32(24, sampleRate, true);
      view.setUint32(28, sampleRate * 2, true);
      view.setUint16(32, 2, true);
      view.setUint16(34, 16, true);
      writeString(view, 36, 'data');
      view.setUint32(40, audioData.length * 2, true);

      // 写入音频数据
      const floatTo16BitPCM = (output, offset, input) => {
        for (let i = 0; i < input.length; i++, offset += 2) {
          const s = Math.max(-1, Math.min(1, input[i]));
          output.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
        }
      };
      floatTo16BitPCM(view, 44, audioData);

      return new Blob([buffer], { type: 'audio/wav' });
    };

    // 写入字符串到DataView
    const writeString = (view, offset, string) => {
      for (let i = 0; i < string.length; i++) {
        view.setUint8(offset + i, string.charCodeAt(i));
      }
    };

    // 进入下一轮
    const nextRound = () => {
      if (currentRound.value < 3) {
        currentRound.value++;
        isPlaying.value=currentRound.value;
        // 使用nextTick确保DOM更新后再播放音频
        nextTick(() => {
          setTimeout(() => {
            let audioElement = document.querySelector(`audio[id=q${currentRound.value}]`);
            console.log(audioElement)
            if (audioElement) {
              // audioElement=audioElement[audioElement.length-1]
              audioElement.play();
            }
          }, 100);
        });
      }
    };

    // 完成面试
    const finishInterview = async () => {
      try {
        const id = route.params.id;
        if (id) {
          var x=await postData('view_ans', {
            id,
            wav1: wav1.value,
            wav2: wav2.value,
            wav3: wav3.value
          });
          resView.value=x.data.view
          resItem.value=x.data.item
          showRes.value=true
          console.log('面试答案提交成功');
        }
      } catch (error) {
        console.error('提交面试答案失败:', error);
      }
    };
    const autoStartRecording = async () => {
  isPlaying.value = 0;
  if (micPermissionGranted.value) {
    await startRecording();
    // 10秒后自动停止录音
    setTimeout(() => {
      if (recording.value) {
        stopRecording();
      }
    }, 10000);
  }
};

return {
  messages,
  recording,
  currentRound,
  wav1,
  wav2,
  wav3,
  wav1Preview,
  wav2Preview,
  wav3Preview,
  startRecording,
  stopRecording,
  nextRound,
  finishInterview,
  recordingTime,
  micPermissionGranted,
  showRes,
  resView,
  resItem,
  showWelcome,
  startInterview,
  autoStartRecording,
  isPlaying
};
  }
};
</script>

<style scoped>
.chat-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 20px;
  background-color: #f5f7fa;
}

.chat-history {
  flex: 1;
  margin-bottom: 20px;
  background-color: white;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.interview-round {
  margin-bottom: 20px;
  padding: 16px;
  border-radius: 8px;
  background-color: #f5f7fa;
}

.question-audio {
  width: 100%;
  margin: 16px 0;
}
.answer-audio {
  width: 100%;
  margin: 10px 0;
}
.voice-input-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 0;
}

.voice-button {
  width: 64px;
  height: 64px;
  font-size: 24px;
}
.voice-hint {
  margin-top: 8px;
  color: #909399;
  font-size: 14px;
  text-align: center;
}
.recording-time {
  margin-top: 4px;
  font-weight: bold;
  color: #409EFF;
}
.recorded-answer {
  text-align: center;
  margin: 20px 0;
}

.welcome-screen {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.welcome-screen h2 {
  margin-bottom: 20px;
  color: #303133;
}

.welcome-screen p {
  margin-bottom: 30px;
  color: #606266;
}

.audio-playing-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  margin: 10px 0;
}

.dot {
  width: 8px;
  height: 8px;
  background-color: #409EFF;
  border-radius: 50%;
  animation: bounce 0.8s infinite;
}

.dot:nth-child(2) {
  animation-delay: 0.2s;
}

.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}
</style>
